import { render, staticRenderFns } from "./ServiceTable.vue?vue&type=template&id=f3b6085c&scoped=true&"
import script from "./ServiceTable.vue?vue&type=script&lang=js&"
export * from "./ServiceTable.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTable.vue?vue&type=style&index=0&id=f3b6085c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b6085c",
  null
  
)

export default component.exports